module.exports = __webpack_public_path__ + "img/news_3.429c8441.png";